const jbColors = {
  core: {
    reflexBlue: {
      100: '#001489',
      70: '#4D5BAE',
      40: '#99A1D0',
    },
    persianBlue: {
      100: '#007FA3',
      50: '#80BFD1',
    },
    stone: {
      80: '#C0BB98',
      40: '#EFEEE9',
      30: '#E5E5E5',
      20: '#EFEEE5',
      10: '#f6f7f7',
    },
    green: {
      100: '#198D16',
    },
  },
  support: {
    greenSmoke: {
      100: '#717C7D',
      80: '#8D9697',
      10: '#F0F1F2',
    },
    alertBlue: {
      110: '#0055D4',
    },
    solidGrayIcon: {
      10: '#AAB0B1',
    },
  },
  technical: {
    amberYellow: {
      100: '#CC8A00',
      80: '#D6A133',
    },
    carminRed: {
      100: '#971B2F',
      80: '#AC4959',
    },
    forestGreen: {
      80: '#339E91',
    },
  },
  app: {
    lightGrey: '#CCCCCC',
  },
  alert: {
    100: '#0080a3',
    80: '#cce5ed',
  },
};

export { jbColors };
